import { DownloadHistory } from '@/types/GraphqlSchema';
import { ApolloError, gql, LazyQueryHookOptions, useLazyQuery } from '@apollo/client';

type DownloadHistoryData = {
  downloadHistory: DownloadHistory[];
};

const DOWNLOAD_HISTORY_QUERY = gql`
  query downloadHistory {
    downloadHistory {
      id
      filename
      finishedAt
      presignedUrl
      requestedAt
      status
      updatedAt
    }
  }
`;

type UseGetDownloadHistoryReturn = {
  getDownloadHistory: () => void;
  downloadHistory: DownloadHistory[];
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetDownloadHistory = (
  options: LazyQueryHookOptions = { fetchPolicy: 'network-only' },
): UseGetDownloadHistoryReturn => {
  const [getDownloadHistory, { data, loading, error }] = useLazyQuery<DownloadHistoryData>(
    DOWNLOAD_HISTORY_QUERY,
    options,
  );

  return {
    getDownloadHistory,
    downloadHistory: data?.downloadHistory || [],
    loading,
    error,
  };
};
